/* The web store's copy of stylon-salon-portal/src/utils/haptics.js — keep the two in step (DESIGN_SYSTEM.md §6). */
/**
 * HAPTICS — one place decides (DESIGN_SYSTEM §6.7). A haptic confirms a change, never a movement:
 *   selection — a step of a slider / range / picker being dragged
 *   light     — a panel or sheet opens because you tapped
 *   medium    — you submit / send
 *   success   — what you asked for is done
 *   warning   — a refusal or a failed send
 *
 * In the phone app through @capacitor/haptics when its build carries the plugin (read off window.Capacitor, so the
 * web build needs no dependency); otherwise a short vibration where the browser has one (Android); otherwise nothing.
 * Never throws, never awaits: a haptic must not delay or break what it confirms.
 */
const VIBRATION = { selection: 6, light: 10, medium: 16, success: [12, 60, 18], warning: [20, 50, 20] };

function nativeHaptics() {
  try {
    const cap = window.Capacitor;
    if (!cap?.isNativePlatform?.() || !cap.isPluginAvailable?.('Haptics')) return null;
    return cap.Plugins?.Haptics || null;
  } catch (_) {
    return null;
  }
}

function quietly(fn) {
  try {
    const out = fn();
    if (out && typeof out.catch === 'function') out.catch(() => {});
  } catch (_) { /* a haptic never breaks what it confirms */ }
}

export function haptic(kind) {
  if (!Object.prototype.hasOwnProperty.call(VIBRATION, kind)) return;
  const native = nativeHaptics();
  if (native) {
    if (kind === 'selection') quietly(() => native.selectionChanged?.());
    else if (kind === 'success') quietly(() => native.notification({ type: 'SUCCESS' }));
    else if (kind === 'warning') quietly(() => native.notification({ type: 'WARNING' }));
    else quietly(() => native.impact({ style: kind === 'medium' ? 'MEDIUM' : 'LIGHT' }));
    return;
  }
  quietly(() => (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function' ? navigator.vibrate(VIBRATION[kind]) : undefined));
}
